import type { CityConfig } from "../city-template/types";

export const willistonConfig: CityConfig = {
  city: "Williston",
  state: "North Dakota",
  stateAbbr: "ND",
  slug: "williston",
  route: "/cities/williston",
  title: "Emergency Passport Williston, ND — Expedited Same-Day Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Williston, ND — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Williston, Bakken energy workers, Williams County, and western ND travelers. No Minneapolis trip needed.",
  h1: "Emergency & Expedited Passport Services in Williston, ND",
  heroSubtitle: "Bakken oil field equipment sourcing trip to Canada next week? Energy conference in the Middle East? Family visit to Saskatchewan? We help Williston residents — from Bakken roughnecks and engineers to downtown business owners — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30-100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20Williston%20North%20Dakota%20skyline%20with%20Missouri%20River%20and%20the%20confluence%20area%2C%20oil%20field%20pump%20jacks%20dotting%20the%20prairie%20landscape%20in%20the%20distance%2C%20downtown%20historic%20buildings%20alongside%20modern%20energy%20industry%20development%2C%20dramatic%20North%20Dakota%20big%20sky%20at%20golden%20sunset%20hour%20with%20warm%20amber%20light%20over%20the%20Bakken%20region%2C%20editorial%20travel%20photography%20with%20crisp%20detail&width=1800&height=700&seq=williston-hero-2026&orientation=landscape",
  heroImageAlt: "Williston North Dakota skyline with Missouri River and Bakken oil fields at golden hour",
  geoPosition: "48.1470;-103.6179",
  geoPlacename: "Williston, North Dakota",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Minneapolis Passport Agency",
    address: "212 3rd Ave S, Suite 200, Minneapolis, MN 55401",
    distance: "Nearest regional passport agency — located approximately 740 miles from Williston; completely impractical for Williams County residents",
  },
  nearbyCitiesZips: [
    { name: "Williston", zips: "58801, 58802" },
    { name: "Watford City", zips: "58854" },
    { name: "Tioga", zips: "58852" },
    { name: "Stanley", zips: "58784" },
    { name: "Ray", zips: "58849" },
    { name: "Trenton", zips: "58853" },
    { name: "Alexander", zips: "58831" },
    { name: "Sidney, MT", zips: "59270" },
  ],
  benefits: [
    { icon: "ri-oil-line", title: "Bakken Energy Industry Expertise", desc: "Williston is the heart of the Bakken oil boom — energy professionals travel internationally for equipment sourcing in Canada, conferences in the Middle East, and technology partnerships in Europe. We understand energy sector travel timelines and expedite accordingly." },
    { icon: "ri-flight-takeoff-line", title: "XWA — Williston Basin International Airport", desc: "Daily flights to Denver, Minneapolis, and seasonal routes. XWA replaced the old Sloulin Field in 2019 — a modern facility serving western North Dakota and eastern Montana. We coordinate processing around your XWA connection." },
    { icon: "ri-map-pin-2-line", title: "Cross-Border Canada Travel Hub", desc: "Williston is just 60 miles south of Saskatchewan — cross-border business and family travel is a daily reality. We process passport cards and books for frequent Canada crossings into Estevan, Regina, and beyond." },
    { icon: "ri-building-2-line", title: "No Minneapolis Trip Possible", desc: "Minneapolis Passport Agency is 740 miles from Williston — an 11+ hour drive. Our registered courier service is not just convenient; it's the only practical option for expedited passport processing in western North Dakota." },
  ],
  internalLinks: [
    { name: "Expedited passport in Minot, ND", route: "/cities/minot" },
    { name: "Fast passport services in Bismarck, ND", route: "/cities/bismarck" },
    { name: "Quick passport services in Fargo, ND", route: "/cities/fargo" },
    { name: "Urgent passport services in Dickinson, ND", route: "/cities/dickinson" },
    { name: "North Dakota passport services overview", route: "/states/north-dakota" },
  ],
  fpcOfficeAddress: "212 3rd Ave S, Suite 200, Minneapolis, MN 55401",
  fpcOfficeNote: "Fast Passport Center serves Williston via secure registered courier with direct access to the Minneapolis Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without an 11+ hour drive to Minnesota. Williston residents can ship from any UPS Store, FedEx Office, or post office location across Williams County.",
  fpcOfficeDistance: "Serving Williston, Watford City, Tioga, Stanley, Ray, Trenton, Alexander, Sidney MT, and all Williams County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Williston and the Bakken region. From the energy industry professionals on the oil fields to the downtown business community, from the new XWA airport travelers to the cross-border Canada visitors — we serve all of Williams County and western North Dakota. Our courier service eliminates the impossible drive to Minneapolis for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Williston and all Williams County communities including Watford City, Tioga, and Stanley. We also serve Bakken oil field workers stationed throughout the region and cross-border travelers heading to Saskatchewan and beyond.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Williston as simple as possible — with the speed and efficiency Bakken energy professionals have come to expect. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Williston travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Williston's energy-driven, cross-border lifestyle creates unique passport situations — from Bakken business travel timing to Canada crossing documentation to rural western ND mail challenges. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Williston travelers — from Bakken roughnecks heading to Canadian oil fields to energy executives flying to the Middle East — trust us when their international departure is days away and Minneapolis is a full day's drive.",
  faqIntro: "Have questions about expedited passports in Williston, ND? Here are the most common ones we hear from Bakken country travelers.",
  statePageRoute: "/states/north-dakota",
  statePageName: "North Dakota",
  servicesIntro: "Whether you need a passport for a Canadian equipment sourcing trip, a Middle East energy conference, or a family vacation connecting through XWA to Denver — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30-100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.nd.gov/divisions/driverslicense/driverslicense.htm",
  dmvLabel: "North Dakota Department of Transportation — Driver License Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Minneapolis agency is 740 miles from Williston", "Completely impossible for Williams County residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2-9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Minneapolis trip needed", "Ideal for Bakken business travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3-5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1-3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Williston", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Last-minute XWA flight to Denver connecting to a Middle East energy conference? Equipment failure requiring a next-day trip to Calgary? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Williston travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Williston residents renew fast — no agency visit required for most renewals. Perfect for Bakken professionals, cross-border travelers, and families planning international trips from XWA.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Williams County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed so your Bakken business trip or XWA connection isn't derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Williston family trip or move stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations and IDs.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Essential for Bakken executives whose primary passport is constantly in visa processing for multiple countries.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Oil field work is tough on everything — including passports. We help Williston workers replace damaged passports quickly so international assignments stay on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is essential for Williston residents who cross into Saskatchewan and Manitoba regularly. Wallet-size convenience for land crossings to Canada — a daily reality in the Bakken.",
      bullets: ["Wallet-size convenience", "Land crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Williston ND", description: "Urgent passport processing for Williston North Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Williston ND", description: "Fast passport renewal for Williston North Dakota residents." },
    { name: "First-Time Passport Williston ND", description: "New passport application services for Williston North Dakota first-time applicants." },
    { name: "Child Passport Williston ND", description: "Minor passport services for Williston North Dakota families with children under 16." },
    { name: "Name Change Passport Williston ND", description: "Passport name correction for Williston residents after marriage or legal name changes." },
    { name: "Second Passport Williston ND", description: "Second passport services for Williston frequent travelers and energy professionals." },
  ],
  testimonials: [
    {
      name: "Cody R.",
      location: "Williston",
      rating: 5,
      text: "I'm a drilling consultant and got called to Saudi Arabia with 10 days' notice. My passport was expired and sitting in my truck's glovebox — covered in Bakken dust. Fast Passport Center got me a renewal in 5 days. In the oil patch, you learn who delivers and who doesn't. These folks deliver.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Maria G.",
      location: "Watford City",
      rating: 5,
      text: "My husband works in the oil fields and we hadn't taken a family vacation in three years. We booked Cancun and then realized all four of us needed new passports. Fast Passport Center handled everything — all four passports arrived in 9 days. We're on that beach right now.",
      service: "Family Passports — 2 Renewals + 2 New",
    },
    {
      name: "Dave H.",
      location: "Williston",
      rating: 5,
      text: "Equipment failure in Saskatchewan — needed to be in Estevan the next morning. My passport card had expired. Fast Passport Center expedited a passport book in 3 days so I could fly commercially. In this business, every hour of downtime costs money. They got it done.",
      service: "Expedited Passport — Canada Business",
    },
    {
      name: "Sarah W.",
      location: "Tioga",
      rating: 5,
      text: "Energy conference in Dubai, invitation came 2 weeks before. Living in Tioga, the nearest passport office might as well be on the moon. Fast Passport Center handled everything remotely. Passport arrived with 3 days to spare. I presented at the conference on time.",
      service: "Expedited Passport Renewal — Middle East Travel",
    },
  ],
  facilities: [
    {
      id: "williston-1",
      name: "Williston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 E Broadway",
      city: "Williston",
      state: "ND",
      zip: "58801",
      phone: "(701) 572-4050",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (appointment required)",
      distance: "Downtown Williston",
      website: "https://tools.usps.com/find-location.htm?location=1388511",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Williams County. Passport photos available on-site. Appointment recommended — Bakken workforce means steady demand for passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "williston-2",
      name: "Watford City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "205 4th St NE",
      city: "Watford City",
      state: "ND",
      zip: "58854",
      phone: "(701) 842-3310",
      hours: "Mon-Fri 8:30 AM - 4:00 PM (appointment required)",
      distance: "Watford City — about 45 miles southeast of Williston",
      website: "https://tools.usps.com/find-location.htm?location=1388379",
      websiteLabel: "USPS Location",
      notes: "Serves McKenzie County and southern Williams County. Growing facility serving the Bakken population. Call ahead for passport acceptance availability.",
      icon: "ri-mail-line",
    },
    {
      id: "williston-3",
      name: "Sidney Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "714 S Central Ave",
      city: "Sidney",
      state: "MT",
      zip: "59270",
      phone: "(406) 433-2222",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (appointment required)",
      distance: "Sidney, MT — about 45 miles southwest of Williston",
      website: "https://tools.usps.com/find-location.htm?location=1384422",
      websiteLabel: "USPS Location",
      notes: "Montana-side option for Williston residents in the southwest part of the Bakken. Serves Richland County, MT and cross-border Bakken workers.",
      icon: "ri-mail-line",
    },
    {
      id: "williston-4",
      name: "Stanley Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "206 S Main St",
      city: "Stanley",
      state: "ND",
      zip: "58784",
      phone: "(701) 628-2315",
      hours: "Mon-Fri 9:00 AM - 3:00 PM (appointment required)",
      distance: "Stanley — about 25 miles east of Williston",
      website: "https://tools.usps.com/find-location.htm?location=1385151",
      websiteLabel: "USPS Location",
      notes: "Serves Mountrail County and eastern Williams County. Smaller facility — call ahead to confirm passport acceptance availability. Limited hours.",
      icon: "ri-mail-line",
    },
    {
      id: "williston-5",
      name: "Minot Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 1st St SW",
      city: "Minot",
      state: "ND",
      zip: "58701",
      phone: "(701) 852-6717",
      hours: "Mon-Fri 9:00 AM - 4:00 PM (appointment required)",
      distance: "Minot — about 130 miles east of Williston",
      website: "https://tools.usps.com/find-location.htm?location=1378262",
      websiteLabel: "USPS Location",
      notes: "Larger facility with more appointment availability. About 2 hours from Williston — useful if combined with other Minot errands. Full passport photo service available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Minneapolis Passport Agency, 740 miles and 11+ hour drive from Williston", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Minneapolis; impossible day trip from Williston", fpc: "Most Williston travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — completely impractical from Williston", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, devastating from rural ND", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Williston", agency: "740-mile drive one way — essentially impossible for Williston residents", fpc: "Entirely remote — forms online, ship from Williston, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in impossible travel to Minneapolis", fpc: "Best price guarantee — 30-100% less than FedEx, Staples and resellers" },
    { feature: "Williston Context", agency: "No Bakken-specific guidance — no oil field, cross-border, or energy sector expertise", fpc: "Full Williston knowledge — Bakken energy, Canada crossings, XWA airport, rural mail" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Canada Cross-Border Documentation Gaps",
      description: "Williston is 60 miles from Saskatchewan and cross-border business is daily life. Many Bakken workers drive to Estevan and Regina assuming a driver's license is sufficient — it's not. Canada requires a valid passport or passport card. We process expedited passport cards specifically for frequent Bakken cross-border travelers.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Oil Field Work Damages Passports",
      description: "Bakken work is rough on everything in your truck — including your passport. Heat, dust, and physical damage from the glovebox can render a passport invalid. We see this regularly from Williston workers and can process replacements fast when a damaged passport derails international travel.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Remote Location Processing Delays",
      description: "Williston is one of the most remote urban areas in the lower 48 states for passport processing. Standard mail from northwestern North Dakota takes 3-5 days each way to processing centers. Our overnight courier channel eliminates this — your documents arrive next day, not next week.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Middle East Energy Conference Timing",
      description: "Bakken executives and engineers regularly travel to Saudi Arabia, UAE, and Qatar for energy conferences. Saudi visa processing alone can take 2-3 weeks, and many countries require 6 months of passport validity. We help energy professionals layer passport and visa timelines to avoid costly delays.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Transient Workforce Document Challenges",
      description: "The Bakken workforce is mobile — workers move between Texas, Oklahoma, North Dakota, and even international assignments. Many have birth certificates stored in a different state or lack local North Dakota IDs. We help transient energy workers assemble the right documents regardless of where they're originally from.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether it's a Bakken business trip, Canada crossing, or family vacation from XWA." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you're on a rig outside Watford City or in downtown Williston." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send documents using overnight shipping. Most Williston clients ship from the UPS Store on 2nd Ave W or the Williston Post Office — no Minneapolis trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our center. We submit through reserved agency slots — so Williston travelers never need to drive 740 miles to Minneapolis." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is shipped directly to your Williston address — whether that's a man camp, downtown apartment, or ranch outside town. No agency visit. No Minneapolis. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Williston, North Dakota?", a: "We offer Williston area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5-10 business days. Because the nearest regional passport agency is in Minneapolis (740 miles away), our remote courier service is the only practical expedited option in northwestern North Dakota." },
    { q: "Do I need to visit a Williston office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Williston Post Office, Watford City Post Office, or Stanley Post Office), then ship documents overnight. We handle State Department submission and return your passport to your Williams County address." },
    { q: "Can Bakken oil field workers get fast passports for Canada travel?", a: "Yes — this is our most common request from Williston. Energy professionals crossing into Saskatchewan and Alberta need valid passports or passport cards. We expedite both types. A passport card processes faster and is ideal for land crossings to Canada — the most frequent travel pattern from western North Dakota." },
    { q: "What if I need a passport and Minneapolis is too far?", a: "Minneapolis Passport Agency is 740 miles from Williston — an 11+ hour drive. It's completely impractical for western North Dakota residents. Our registered courier service is the only real option for expedited passport processing from Williston." },
    { q: "What is the best price for expedited passport service in Williston?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30-100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "Can I get a passport photo in Williston?", a: "Yes. The Williston Post Office offers on-site passport photos. Walgreens and Walmart in Williston also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does rural mail delivery affect passport processing from Williston?", a: "Rural Williams County mail routes can add 3-5 extra days in each direction. For Bakken professionals with tight international deadlines, this is unacceptable. We use overnight courier shipping to eliminate rural mail delays — your documents arrive the next business day." },
    { q: "Can you help with passports for Middle East energy conference travel?", a: "Yes. Bakken executives and engineers traveling to Saudi Arabia, UAE, Qatar, and Kuwait for energy conferences are frequent clients. We coordinate passport processing timelines with visa application windows for Middle Eastern countries, which can take 2-3 weeks for processing." },
    { q: "What documents do Williston applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. For Bakken workers who may have documents stored in another state, we provide guidance on obtaining certified copies quickly." },
    { q: "Does XWA airport have international flights?", a: "Williston Basin International Airport (XWA) primarily offers domestic connections to Denver and Minneapolis. International travelers connect through those hubs. Your passport must be valid at XWA check-in — airlines verify documents before you board your first flight, not just at the international connection." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Williston Residents",
    intro: "Williston's position at the heart of the Bakken — minutes from Canada, hours from anywhere else — creates some of the most demanding passport timing needs in the country. Here's what Bakken travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "XWA — Williston Basin International Airport",
        subtitle: "Western North Dakota's modern air gateway",
        description: "XWA opened in 2019, replacing the old Sloulin Field with a modern terminal serving United and Delta flights to Denver and Minneapolis. The airport is a lifeline for the Bakken — connecting energy professionals to global hubs. Most international travelers connect through Denver (DEN) for global flights, though Minneapolis connections are also available.",
        tip: "XWA check-in agents verify passport validity before your first flight. If your passport is expired, you won't board the Denver connection — meaning your international trip is dead before it starts. Check your passport before heading to XWA.",
      },
      {
        icon: "ri-oil-line",
        title: "Bakken Energy International Travel",
        subtitle: "Oil field professionals with global responsibilities",
        description: "The Bakken has made Williston a global energy hub. Professionals travel to Canada for field operations and equipment, to the Middle East for OPEC-adjacent conferences and technology showcases, and to Europe for engineering partnerships. These trips often materialize with 1-3 weeks' notice — requiring passport processing that keeps pace with energy industry speed.",
        tip: "Bakken professionals should maintain 6+ months of passport validity proactively. When a Saudi Arabia or UAE trip appears with 2 weeks' notice, having a valid passport already in hand eliminates the biggest variable.",
      },
      {
        icon: "ri-map-pin-2-line",
        title: "Saskatchewan & Manitoba Crossings",
        subtitle: "Daily cross-border business and family travel",
        description: "Williston sits 60 miles from the Saskatchewan border. The Portal/North Portal crossing on US-52 and the Raymond/Regway crossing on MT-16 are heavily used by Bakken workers, agricultural businesses, and families with cross-border connections. Passport cards are particularly popular here — they're wallet-sized, cheaper, and perfect for land crossings.",
        tip: "Passport cards process faster than passport books and are all most Williston residents need for Canada crossings. If you only travel to Canada by road, a passport card is the most practical option.",
      },
      {
        icon: "ri-truck-line",
        title: "Bakken Workforce Mobility",
        subtitle: "A transient workforce with document challenges",
        description: "The Bakken workforce is famously mobile — workers cycle through from Texas, Oklahoma, Louisiana, and beyond. Many don't have their vital documents with them in North Dakota. Birth certificates are in a safe deposit box back home, previous passports were issued in a different state — creating documentation puzzles when international travel suddenly becomes necessary.",
        tip: "If you're a Bakken worker from another state, start gathering documents early. We can guide you through obtaining certified copies of out-of-state birth certificates and help with the specific requirements for applicants whose documents originate outside North Dakota.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Williston & the Canadian Energy Corridor",
      description: "The Bakken formation doesn't stop at the border — it extends deep into Saskatchewan and Manitoba. Williston energy professionals regularly cross into Canada for field operations, equipment sourcing, and joint venture meetings. The Portal/North Portal crossing is open 24/7 and is one of the busiest rural border crossings in the northern plains — part of daily life in the Bakken.",
    },
  },
  destinations: {
    title: "Where Williston Travelers Go — And Why Passports Get Urgent",
    intro: "Williston's energy-driven economy and cross-border geography shape a unique international travel profile.",
    stats: [
      { stat: "50%", label: "of Williston expedited requests involve Canada cross-border business" },
      { stat: "1-3 Weeks", label: "average lead time from trip booking to departure for Bakken travelers" },
      { stat: "Year-Round", label: "steady passport demand — energy industry doesn't have an off-season" },
      { stat: "740 Miles", label: "distance to nearest passport agency — our courier makes the impossible possible" },
    ],
    destinations: [
      { name: "Canada", context: "Saskatchewan and Alberta energy operations, equipment sourcing in Calgary and Edmonton, Estevan and Regina field offices, cross-border family visits", urgency: "Year-round steady demand — the most common passport need in Williston", icon: "ri-map-pin-2-line" },
      { name: "Middle East", context: "Saudi Arabia energy conferences, UAE technology showcases, Qatar and Kuwait operations, OPEC meetings and industry summits", urgency: "2-4 week turnaround typical — visa processing adds additional time", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Norway and UK North Sea energy technology partnerships, German and Dutch engineering collaborations, equipment manufacturing site visits", urgency: "3-6 week planning window for conference and business travel", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Bakken worker vacation getaways, resort trips from the long North Dakota winter, cruise departures through Denver connections", urgency: "Fall and winter bookings as workers plan warm escapes", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "Energy technology sourcing in China and Japan, pipeline equipment procurement, engineering collaborations", urgency: "Longer lead times — typically 4-8 weeks for procurement trips", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "Brazil and Argentina energy sector partnerships, Colombia and Venezuela consulting, emerging market energy development", urgency: "Variable timelines depending on project stages", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other North Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Peace Garden State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Minot", route: "/cities/minot" },
      { name: "Bismarck", route: "/cities/bismarck" },
      { name: "Dickinson", route: "/cities/dickinson" },
    ],
  },
  photoLocations: [
    { name: "Williston Post Office", address: "120 E Broadway, Williston, ND 58801", hours: "Mon-Fri 9 AM - 3:30 PM (photo service available)" },
    { name: "Walmart Supercenter — Williston", address: "4001 2nd Ave W, Williston, ND 58801", hours: "Daily 6 AM - 11 PM" },
    { name: "Walgreens — Williston", address: "106 26th St E, Williston, ND 58801", hours: "Daily 8 AM - 10 PM" },
    { name: "The UPS Store — Williston", address: "1804 2nd Ave W, Williston, ND 58801", hours: "Call for hours" },
    { name: "Watford City Post Office", address: "205 4th St NE, Watford City, ND 58854", hours: "Mon-Fri 8:30 AM - 4 PM" },
  ],
  dmvLocations: [
    {
      name: "North Dakota DOT — Williston Driver License Office",
      address: "205 E Broadway, Williston, ND 58801",
      hours: "Mon-Fri, 8:00 AM - 4:45 PM (appointment recommended)",
      note: "Driver licenses, REAL ID, vehicle registration. Located downtown Williston. Serves Williams County.",
      featured: true,
    },
    {
      name: "Williams County Treasurer — Motor Vehicle",
      address: "205 E Broadway, Williston, ND 58801",
      hours: "Mon-Fri, 8:00 AM - 4:30 PM",
      note: "Vehicle registration and title services. For driver licenses, visit the ND DOT office in the same building.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "XWA",
      name: "Williston Basin International Airport",
      distance: "About 10 miles northwest of downtown Williston",
      address: "14127 Highway 2, Williston, ND 58801",
      note: "Modern facility opened in 2019 replacing Sloulin Field. Daily United flights to Denver and Delta flights to Minneapolis. Primary air gateway for Bakken energy travelers and Williams County residents connecting to international flights.",
      flightUrl: "https://www.flywilliston.net/",
      flightLabel: "XWA Airport Website",
      featured: true,
    },
    {
      code: "SDY",
      name: "Sidney-Richland Regional Airport",
      distance: "About 45 miles southwest of Williston (near Sidney, MT)",
      address: "540 Airport Rd, Sidney, MT 59270",
      note: "Montana-side alternative with Cape Air flights to Billings. Limited commercial service but useful for connections to Montana hubs.",
      flightUrl: "https://www.richland.org/airport",
      flightLabel: "Sidney Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified North Dakota birth certificates from the ND Department of Health Vital Records. Online, mail, or in-person options available in Bismarck.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through ND Department of Health Vital Records. Required for estate and legal matters in Williams County.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Williams County Clerk of Court. Certified copies available for name changes and passport applications.",
      url: "https://www.williamsnd.com/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Williams County District Court. Required for name change passport corrections.",
      url: "https://www.williamsnd.com/",
    },
  ],
};